export default {"src":"/_next/static/media/s.c3938808.svg","height":2000,"width":2278,"blurWidth":0,"blurHeight":0};